import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Download, Menu, X } from "lucide-react";
import { Button } from "./ui/button";
import { profile, navLinks } from "../data/mock";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";
  const linkPrefix = isHome ? "#" : "/#";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleDownload = () => {
    // Placeholder — wire up to a real PDF later
    window.alert("Resume download will be wired to a real PDF.");
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-[#04100f]/80 backdrop-blur-md border-b border-teal-500/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <a href={isHome ? "#top" : "/"} className="flex items-center gap-2 group">
          <span className="w-9 h-9 rounded-md bg-gradient-to-br from-teal-400 to-teal-700 flex items-center justify-center text-[#04100f] font-display font-bold">
            {profile.initials}
          </span>
          <span className="font-display font-semibold tracking-tight text-slate-100 group-hover:text-teal-300 transition-colors">
            {profile.name.split(" ")[0] || "Portfolio"}
            <span className="text-teal-400">.</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((l) => (
            <a
              key={l.id}
              href={`${linkPrefix}${l.id}`}
              className="text-sm text-slate-300 hover:text-teal-300 transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:block">
          <Button
            onClick={handleDownload}
            className="bg-teal-400 text-[#04100f] hover:bg-teal-300 font-medium"
          >
            <Download className="w-4 h-4 mr-2" />
            Resume
          </Button>
        </div>

        <button
          className="md:hidden text-slate-200"
          onClick={() => setOpen((s) => !s)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-teal-500/10 bg-[#04100f]/95 backdrop-blur">
          <div className="px-6 py-4 flex flex-col gap-3">
            {navLinks.map((l) => (
              <a
                key={l.id}
                href={`${linkPrefix}${l.id}`}
                onClick={() => setOpen(false)}
                className="text-slate-200 hover:text-teal-300 py-1"
              >
                {l.label}
              </a>
            ))}
            <Button
              onClick={handleDownload}
              className="bg-teal-400 text-[#04100f] hover:bg-teal-300 font-medium mt-2 w-full"
            >
              <Download className="w-4 h-4 mr-2" />
              Download Resume
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
